import { render, staticRenderFns } from "./NavSubmenu.vue?vue&type=template&id=49e0ca0e&"
import script from "./NavSubmenu.vue?vue&type=script&lang=js&"
export * from "./NavSubmenu.vue?vue&type=script&lang=js&"
import style0 from "./NavSubmenu.vue?vue&type=style&index=0&id=49e0ca0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports